import constants from "config/constants";
import { useNavigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";

function Contact() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const onBookConsultation = () => {
    confirmQuestionnaireFlow();
  };

  const confirmQuestionnaireFlow = () => {
    // setShowQuestionnaireModal(false);
    setTimeout(() => {
      if (isAuthenticated) {
        navigate("/questionnaire");
      } else {
        window.dispatchEvent(new Event("openLoginModal"));
      }
    }, 300);
  };

  return (
    <div
      style={{
        padding: "80px 20px",
        maxWidth: "1440px",
        margin: "0 auto",
      }}
    >
      <div
        style={{
          textAlign: "center",
          marginBottom: "60px",
        }}
      >
        <h1
          style={{
            fontSize: "3rem",
            fontWeight: "700",
            color: "#1a2e1a",
            marginBottom: "20px",
          }}
        >
          Get In Touch
        </h1>
        <p
          style={{
            fontSize: "1.2rem",
            color: "#666",
            lineHeight: "1.6",
            maxWidth: "600px",
            margin: "0 auto",
          }}
        >
          Ready to begin your healing journey? We're here to help you find the
          right herbal solutions for your wellness needs.
        </p>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "40px",
          marginBottom: "60px",
        }}
      >
        <div
          style={{
            background: "#f8faf8",
            padding: "40px",
            borderRadius: "20px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              width: "60px",
              height: "60px",
              background: "#4CAF50",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
              color: "white",
              fontSize: "24px",
            }}
          >
            📧
          </div>
          <h3
            style={{
              fontSize: "1.5rem",
              color: "#1a2e1a",
              marginBottom: "15px",
            }}
          >
            Email Us
          </h3>
          <p
            style={{
              color: "#666",
              lineHeight: "1.6",
              fontSize: "1.1rem",
            }}
          >
            {constants.contact.emailAddress}
          </p>
        </div>

        <div
          style={{
            background: "#f8faf8",
            padding: "40px",
            borderRadius: "20px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              width: "60px",
              height: "60px",
              background: "#4CAF50",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
              color: "white",
              fontSize: "24px",
            }}
          >
            📞
          </div>
          <h3
            style={{
              fontSize: "1.5rem",
              color: "#1a2e1a",
              marginBottom: "15px",
            }}
          >
            Call Us
          </h3>
          <p
            style={{
              color: "#666",
              lineHeight: "1.6",
              fontSize: "1.1rem",
            }}
          >
            {constants.contact.phoneNumber}
          </p>
        </div>

        <div
          style={{
            background: "#f8faf8",
            padding: "40px",
            borderRadius: "20px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              width: "60px",
              height: "60px",
              background: "#4CAF50",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
              color: "white",
              fontSize: "24px",
            }}
          >
            📍
          </div>
          <h3
            style={{
              fontSize: "1.5rem",
              color: "#1a2e1a",
              marginBottom: "15px",
            }}
          >
            Visit Us
          </h3>
          <p
            style={{
              color: "#666",
              lineHeight: "1.6",
              fontSize: "1.1rem",
            }}
          >
            {constants.contact.officeAddress}
          </p>
        </div>
      </div>

      <div
        style={{
          background: "linear-gradient(135deg, #1a2e1a 0%, #0f1f0f 100%)",
          padding: "60px 40px",
          borderRadius: "30px",
          textAlign: "center",
          color: "white",
        }}
      >
        <h2
          style={{
            fontSize: "2rem",
            marginBottom: "20px",
          }}
        >
          Schedule a Consultation
        </h2>
        <p
          style={{
            fontSize: "1.1rem",
            marginBottom: "30px",
            opacity: "0.9",
          }}
        >
          Get personalized herbal recommendations from our TCM practitioners
        </p>
        <button
          style={{
            background: "linear-gradient(135deg, #e91e63 0%, #ad1457 100%)",
            border: "none",
            borderRadius: "50px",
            padding: "16px 32px",
            color: "white",
            fontSize: "1rem",
            fontWeight: "600",
            cursor: "pointer",
            transition: "all 0.3s ease",
          }}
          onClick={onBookConsultation}
        >
          Book Consultation
        </button>
      </div>
    </div>
  );
}

export default Contact;
